<label class="block text-xs sm:text-sm font-medium text-slate-700 mb-2">
  Cliente
  @if (cliente()?.nombre_completo != null) {
    <span class="font-normal text-slate-400">
      - {{ cliente()?.tipo_documento }} {{ cliente()?.dniRuc }}
    </span>
  }
</label>
<div class="relative">
  @if (cliente()?.id == null) {
    <!-- Modo búsqueda -->
    <div
      class="flex items-center w-full rounded-lg border border-slate-200 bg-white transition-all duration-150 focus-within:ring-2 focus-within:ring-accent-500/20 focus-within:border-accent-500 hover:border-slate-300"
    >
      <span class="flex items-center justify-center pl-3 pr-2 text-slate-400 shrink-0">
        <i class="bi bi-search text-sm"></i>
      </span>
      <input
        type="text"
        class="w-full border-0 bg-transparent py-2 pr-3 text-sm text-slate-700 placeholder:text-slate-400 focus:outline-none focus:ring-0"
        [value]="searchText()"
        (input)="onQueryChange($any($event.target).value)"
        placeholder="Buscar cliente..."
        aria-label="Buscar cliente"
      />
    </div>
  } @else {
    <!-- Modo cliente seleccionado -->
    <div
      class="flex items-center gap-2 rounded-lg border border-emerald-200 bg-emerald-50 px-3 py-2"
    >
      <i class="bi bi-person-check text-emerald-600 shrink-0"></i>
      <span class="flex-1 text-sm font-medium text-emerald-800 truncate">
        {{ cliente()!.nombre_completo }}
      </span>
      <app-button
        icon="bi bi-x"
        variant="ghost"
        size="xs"
        ariaLabel="Quitar cliente"
        (onClick)="clearCliente()"
      />
    </div>
  }
  @if (dropdownOpen()) {
    <div class="fixed inset-0 z-40" (click)="closeDropdown()"></div>
    <ul
      class="absolute left-0 right-0 top-full z-50 mt-1.5 max-h-60 overflow-y-auto rounded-xl border border-slate-200 bg-white shadow-lg animate-fade-in"
    >
      @for (item of clientes(); track item.id) {
        <li>
          <button
            type="button"
            class="w-full px-3.5 py-2.5 text-left text-sm text-slate-700 hover:bg-slate-50 transition-colors focus:outline-none focus:bg-slate-50"
            (click)="selectCliente(item)"
          >
            <span class="font-medium">{{ item.nombre_completo }}</span>
            <span class="text-slate-400 ml-2">{{ item.dniRuc }}</span>
          </button>
        </li>
      } @empty {
        <li class="px-3.5 py-3 text-sm text-slate-400 text-center">Sin resultados</li>
      }
    </ul>
  }
</div>
@if (mostar_creador() === true) {
  <button
    class="mt-1 text-accent-600 text-xs sm:text-sm flex items-center gap-1 hover:underline py-1 transition-colors"
    (click)="modal_crear_cliente = true"
  >
    <span class="text-lg leading-none">+</span> Crear nuevo cliente
  </button>
}

<app-dialog header="Crear cliente" [(visible)]="modal_crear_cliente" size="4xl">
  <app-crear-cliente (crear)="onCreated($event)" />
</app-dialog>
